import { AbsenceRequest, ActivityResponse, HistoryEntryResponse, CaseResponse, PagedResponse, SaveUserRequest, UserResponse } from '../types/types';
import { HttpResponse, makeRequest } from './index';

const endpoint = 'User';

export const getUser = async (userId: string): Promise<HttpResponse<UserResponse>> => {
	const result = await makeRequest<string, UserResponse>(`${endpoint}?userId=${userId}`, null, 'get');
	return result;
};

export const getCurrentUser = async (): Promise<HttpResponse<UserResponse>> => {
	const result = await makeRequest<null, UserResponse>(`${endpoint}/current`, null, 'get');
	return result;
};

export const saveUser = async (request: SaveUserRequest): Promise<HttpResponse<UserResponse>> => {
	const result = await makeRequest<SaveUserRequest, UserResponse>(`${endpoint}`, request, 'put');
	return result;
};

export const addRoleToUser = async (userId: string, roleName: string): Promise<HttpResponse<UserResponse>> => {
	const result = await makeRequest<string, UserResponse>(`${endpoint}/role?userId=${userId}&roleName=${roleName}`, null, 'post');
	return result;
};

export const removeRoleFromUser = async (userId: string, roleName: string): Promise<HttpResponse<UserResponse>> => {
	const result = await makeRequest<string, UserResponse>(`${endpoint}/role?userId=${userId}&roleName=${roleName}`, null, 'delete');
	return result;
};

export const createUserAbsence = async (request: AbsenceRequest): Promise<HttpResponse<null>> => {
	const result = await makeRequest<AbsenceRequest, null>(`${endpoint}/absence`, request, 'post');
	return result;
};

export const updateUserAbsence = async (request: AbsenceRequest): Promise<HttpResponse<null>> => {
	const result = await makeRequest<AbsenceRequest, null>(`${endpoint}/absence`, request, 'put');
	return result;
};

export const deleteUserAbsence = async (id: string): Promise<HttpResponse<null>> => {
	const result = await makeRequest<string, null>(`${endpoint}/absence?absenceId=${id}`, null, 'delete');
	return result;
};

export const deactivateUser = async (id: string): Promise<HttpResponse<null>> => {
	const result = await makeRequest<string, null>(`${endpoint}/deactivate?userId=${id}`, null, 'post');
	return result;
};

export const activateUser = async (id: string): Promise<HttpResponse<null>> => {
	const result = await makeRequest<string, null>(`${endpoint}/activate?userId=${id}`, null, 'post');
	return result;
};

export const getUserActivities = async (): Promise<HttpResponse<ActivityResponse[]>> => {
	const result = await makeRequest<string, ActivityResponse[]>(`${endpoint}/activities`, null, 'get');
	return result;
};

// page ist 0-basiert; die Gesamtanzahl steht in totalCount (bis OEWR-91: Header X-Total-Count, bisher nirgends genutzt)
export const getUserCases = async (page: number = 0, pageSize: number = 10): Promise<HttpResponse<PagedResponse<CaseResponse>>> => {
	const result = await makeRequest<null, PagedResponse<CaseResponse>>(`${endpoint}/cases?page=${page}&pageSize=${pageSize}`, null, 'get');
	return result;
};

export const getUserLogs = async (userId: string): Promise<HttpResponse<HistoryEntryResponse[]>> => {
	const result = await makeRequest<string, HistoryEntryResponse[]>(`${endpoint}/history?userId=${userId}`, null, 'get', false, false);
	return result;
};

export const deleteContact = async (userId: string): Promise<HttpResponse<string>> => {
	const result = await makeRequest<string, string>(`${endpoint}/contact?userId=${userId}`, null, 'delete');
	return result;
};
